if (!customElements.get('complete-the-look')) {
    customElements.define(
        'complete-the-look',
        class CompleteTheLook extends BulkAdd {
            constructor() {
                super();
                this.quantity = 1;
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                const debouncedOnChange = debounce((event) => {
                    if (parseInt(event.target.value) === 0) {
                        this.startQueue(event.target.dataset.index, parseInt(this.quantity));
                    } else {
                        this.validateQuantity(event);
                    }
                }, ON_CHANGE_DEBOUNCE_TIMER);

                this.addEventListener('change', debouncedOnChange.bind(this));
                this.listenForATCClick();
                this.lastActiveInputId = null;
                const pageParams = new URLSearchParams(window.location.search);
                window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
            }

            getATC() {
                return this.querySelector('.complete-the-look__atc');
            }

            selectProgressBar() {
                return this.querySelector('.progress-bar-container');
            }

            listenForATCClick() {
                if (!this.classList.contains('hidden')) {
                    this.getATC().addEventListener('click', (event) => {
                        event.preventDefault()

                        const lookItems = event.currentTarget.closest('.look-wrapper').querySelectorAll('.js-look-items');

                        lookItems.forEach(item => {
                            let variantId = item.querySelector('.product-variant-id').value
                            this.startQueue(parseInt(variantId), parseInt(this.quantity));
                        })
                    });
                }
                this.isEnterPressed = false;
            }

            updateMultipleQty(items) {
                this.selectProgressBar().classList.remove('hidden');

                const ids = Object.keys(items);

                let itemsToAdd = ids.map(id => {
                    return {
                        id: id,
                        quantity: this.quantity
                    };
                })
                const body = JSON.stringify({
                    items: itemsToAdd,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: this.getSectionsUrl(),
                });

                fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                    .then((response) => {
                        return response.text();
                    })
                    .then((state) => {
                        const parsedState = JSON.parse(state);
                        this.renderSections(parsedState, ids);
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
                    })
                    .catch(() => {
                        // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
                        // e.target.setCustomValidity(error);
                        // e.target.reportValidity();
                        // this.resetQuantityInput(ids[index]);
                        // this.selectProgressBar().classList.add('hidden');
                        // e.target.select();
                        // this.cleanErrorMessageOnType(e);
                    })
                    .finally(() => {
                        this.selectProgressBar().classList.add('hidden');
                        // slide cart edits - start
                        if (window.SLIDECART && typeof SLIDECART_OPEN === 'function') {
                          window.SLIDECART_OPEN();
                          window.SLIDECART_UPDATE();
                        } else {
                          this.cart.open(this.getATC());
                        }
                        // slide cart edits - end
                        this.requestStarted = false;
                    });
            }

            getSectionsToRender() {
                return [
                    {
                        id: 'cart-icon-bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section',
                    },
                    {
                        id: 'CartDrawer',
                        selector: '#CartDrawer',
                        section: 'cart-drawer',
                    },
                ];
            }

            renderSections(parsedState, ids) {
                const intersection = this.queue.filter((element) => ids.includes(element.id));
                if (intersection.length !== 0) return;
                this.getSectionsToRender().forEach((section) => {
                    const sectionElement = document.getElementById(section.id);
                    if (
                        sectionElement &&
                        sectionElement.parentElement &&
                        sectionElement.parentElement.classList.contains('drawer')
                    ) {
                        parsedState.items.length > 0
                            ? sectionElement.parentElement.classList.remove('is-empty')
                            : sectionElement.parentElement.classList.add('is-empty');

                        setTimeout(() => {
                            document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
                        });
                    }
                    const elementToReplace =
                        sectionElement && sectionElement.querySelector(section.selector)
                            ? sectionElement.querySelector(section.selector)
                            : sectionElement;
                    if (elementToReplace) {
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                            parsedState.sections[section.section],
                            section.selector
                        );
                    }
                });

                this.listenForATCClick();
            }
        }
    );
}
